/// <reference path="../_references.ts"/>

module App.User {
	angular.module('user', ['login'])
		.factory('UserSession', UserSessionFactory)
		.controller('UserMenuController', UserMenuController);
}
